module.exports = __webpack_public_path__ + "img/unstable.0586a033.svg";